import { useEffect, useSyncExternalStore } from "react";

// Pages with a bar fixed at the bottom of the screen (« Enregistrer les modifications », « Terminer »…) declare it here, so the
// Copilote's bubble moves above it instead of covering its buttons; a full-screen entry page can also hide it on a phone.
// One shared store, so no page moves the bubble its own way.
const bars = new Map();
let nextId = 0;
const listeners = new Set();
let snapshot = { raised: false, hiddenOnMobile: false };

function publish() {
  const values = [...bars.values()];
  snapshot = { raised: values.some((bar) => bar.raise), hiddenOnMobile: values.some((bar) => bar.hideOnMobile) };
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useCopilotDock() {
  return useSyncExternalStore(subscribe, () => snapshot);
}

export function useBottomBar(active, { hideOnMobile = false, raise = true } = {}) {
  useEffect(() => {
    if (!active) return undefined;
    const id = nextId++;
    bars.set(id, { hideOnMobile, raise });
    publish();
    return () => {
      bars.delete(id);
      publish();
    };
  }, [active, hideOnMobile, raise]);
}
